import { Tag } from 'primereact/tag'
import { EventType } from 'features/dashboard/types/camera-event'
import { formatTime } from 'features/dashboard/utils/notification-utils'



interface CameraEvent {
  cameraId: string
  eventType: string
  timestamp: string
  imageBase64: string
  metadata: Record<string, string>
}

interface CameraStatusCardProps {
  event: CameraEvent
  index: number
}

const getCameraStatusInfo = (eventType: string) => {
  switch (eventType) {
    case EventType.CameraStarting:
      return {
        icon: 'pi-refresh',
        label: 'Câmera Iniciando',
        severity: 'info' as const,
      }
    case EventType.CameraStopped:
      return {
        icon: 'pi-times-circle',
        label: 'Câmera Parada',
        severity: 'danger' as const,
      }
    case EventType.CameraRestarting:
      return {
        icon: 'pi-replay',
        label: 'Câmera Reiniciando',
        severity: 'warning' as const,
      }
    default:
      return {
        icon: 'pi-info-circle',
        label: 'Status Desconhecido',
        severity: 'secondary' as const,
      }
  }
}

export const CameraStatusCard = ({ event, index }: CameraStatusCardProps) => {
  const statusInfo = getCameraStatusInfo(event.eventType)

  return (
    <div
      key={`status-${index}`}
      className='notification-grid-item camera-status-item'
    >
      <div className='camera-status-content'>
        <div className='status-icon-section'>
          <i className={`pi ${statusInfo.icon}`}></i>
        </div>
        <div className='status-info-section'>
          <div className='status-header'>
            <Tag
              severity={statusInfo.severity}
              value={statusInfo.label}
              icon={`pi ${statusInfo.icon}`}
            />
          </div>
          <div className='camera-name'>
            <i className='pi pi-video'></i>
            <span>{event.cameraId}</span>
          </div>
          <div className='status-timestamp'>{formatTime(event.timestamp)}</div>
        </div>
      </div>
    </div>
  )
}
